import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiSingleResponse } from '../interfaces/responses/api-response';

/**
 * Chiffres du tableau de bord d'administration. Tous comptés en base :
 * aucun indicateur n'est estimé.
 */
export interface AdminOverview {
  activeStudents: number;
  activeProfessors: number;
  activeSubjects: number;
  activeGroups: number;
  sessionsToday: number;
  sessionsNextSevenDays: number;
  /** Séances en ligne passées dont le journal ne prouve pas la tenue. */
  sessionsToReview: number;
  pendingRegistrations: number;
}

@Injectable({ providedIn: 'root' })
export class AdminOverviewService {
  private readonly http = inject(HttpClient);

  getOverview(): Observable<ApiSingleResponse<AdminOverview>> {
    return this.http.get<ApiSingleResponse<AdminOverview>>(
      `${environment.BASE_URL}/admin/overview`,
    );
  }
}
